module.exports = __webpack_public_path__ + "img/500_icon.0e5de07f.png";